var map = {
	"./br/PT/S1/bg_p115.jpg": 88605,
	"./br/PT/bg_p115.jpg": 97367,
	"./in/EN/S1/bg_p115.jpg": 87582,
	"./ph/EN/S1/bg_p115.jpg": 25604,
	"./ph/EN/bg_p115.jpg": 325,
	"./vn/VI/S1/bg_p115.jpg": 39356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34083;